<template>
  <div
    v-if="state === 'Assign'"
    class="department-assign all-labels"
    @click="handleClick"
  >
    <span class="plus-icon">
      <img :src="plus" alt="Plus" />
    </span>
    <span class="hierarchy-icon">
      <img :src="organizationChart" alt="Organization Chart" />
    </span>
    <span class="label-department">Assign</span>
  </div>
  <div
    v-else-if="state === 'Assigned'"
    class="department-tag all-labels"
  >
    <span class="hierarchy-icon">
      <img :src="department" alt="Organization Chart" />
    </span>
    <span class="label-department dynamic-label">{{ label || 'Department name' }}</span>
  </div>
  <div
    v-else
    class="department-tag all-labels"
    :class="{ 'is-removable': state === 'Assigned Removable' }"
  >
    <span class="hierarchy-icon">
      <img :src="department" alt="Organization Chart" />
    </span>
    <span class="label-department dynamic-label">{{ label || 'Department name' }}</span>
    <EXTooltip
      v-if="state === 'Assigned Removable'"
      class="close-icon-department-tip"
      title="Remove department"
      placement="top"
      :delay="100"
      show-on-child-focus
    >
      <button
        type="button"
        class="close-icon-department"
        aria-label="Remove department"
        @click.stop="handleRemove"
      >
        <img :src="tagCloseX" alt="Tag Close X" />
      </button>
    </EXTooltip>
  </div>
</template>

<script setup>
import EXTooltip from '@components/tooltip/EXTooltip.vue';
import organizationChart from '@components/assets/Organization-chart.svg';
import tagCloseX from '@components/assets/TagcloseX.svg';
import plus from '@components/assets/department-plus.svg';
import department from '@components/assets/Department.svg';

const props = defineProps({
  state: {
    type: String,
    default: 'Assign',
    validator: (value) => ['Assign', 'Assigned Removable', 'Assigned'].includes(value),
  },
  label: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['onClick', 'onRemove']);

function handleClick() {
  emit('onClick');
}

function handleRemove() {
  emit('onRemove');
}
</script>

<style scoped>
.department-assign {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px 2px 4px;
  background: #f9f5ff;
  border: 1px solid #d6bbfb;
  border-radius: 6px;
  color: #53389e;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
  box-shadow: 0px 1px 2px 0px #1018280d;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.department-assign:hover {
  background: #f4ebff;
  border-color: #d6bbfb;
}

.department-assign:active {
  background: #ebe9fe;
}

.department-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px 2px 4px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  color: #344054;
  user-select: none;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
}

.department-tag.is-removable {
  padding: 2px 2px 2px 4px;
}

.all-labels .label-department {
  white-space: nowrap;
  position: relative;
  left: 2px;
  top: -0.8px;
}

.all-labels .dynamic-label {
  top: 0px;
}

.hierarchy-icon {
  display: flex;
  align-items: center;
  color: #667085;
}

.department-assign .hierarchy-icon {
  color: #6941c6;
}

.plus-icon {
  display: flex;
  align-items: center;
  color: #6941c6;
}

.close-icon-department-tip {
  display: inline-flex;
  line-height: 0;
}

.close-icon-department {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #98a2b3;
  padding: 2px;
  border: none;
  background: transparent;
  border-radius: 4px;
  transition: all 0.2s;
  margin-left: 2px;
}

.close-icon-department:hover {
  background: #f2f4f7;
  color: #667085;
}

.close-icon-department img {
  width: 12px;
  height: 12px;
}
</style>
